export default __webpack_public_path__ + "static/media/trazabilidad.43b6175f.png";